import { render, staticRenderFns } from "./CloseDiscrepancyRemark.vue?vue&type=template&id=a5273dc2&"
import script from "./CloseDiscrepancyRemark.vue?vue&type=script&lang=js&"
export * from "./CloseDiscrepancyRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports